import React from "react";
import './notFound.css';
import { Link, Navigate } from "react-router-dom";

function NotFound() {

    const loginData = JSON.parse(sessionStorage.getItem('loginData'));
    const isUserAuthenticated = loginData && loginData?.access_token

    if (!isUserAuthenticated) {
        return <Navigate to='/not-authorize' />
    }

    return (
        <div className="notFoundPage">
            <div className="toCenterAlignNotFound">
                Sorry,  the page you are looking for doesn't exist.
                <div className="dashboardLink">Go to <Link to="/dashboard">Dashboad</Link></div>
            </div>
        </div>
    )
}

export default NotFound;